import React, { useState, useEffect } from "react";
import "./Related_category.css";

import "swiper/css";
import "swiper/css/pagination";

import Heading_title from "../../common-components/common-title/heading-title/Heading_title";
import Product_card from "../../common-components/common-card/product-card/Product_card";
import All_products from "../../common-components/all-products/All_products";

import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";

import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import { getProducts } from "../../../utils/apis/products/Product";
import { IDS } from "../../../utils/common";
import { Context } from "../../../utils/context";

const Related_category = () => {
  const [products, setProducts] = useState([]);

  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await getProducts();

      if (response?.success) {
        const productData = response?.data || [];

        setProducts(productData);

        if (productData.length > 0) {
          const firstCategory = productData[0]?.Category?.name || "";

          setActiveTab(firstCategory);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Group products by category
  const groupedProducts = products.reduce((acc, product) => {
    const categoryName = product?.Category?.name || "Others";

    if (!acc[categoryName]) {
      acc[categoryName] = [];
    }

    acc[categoryName].push(product);

    return acc;
  }, {});

  const categoryKeys = Object.keys(groupedProducts);

  return (
    <>
      <section className="Related_category_sec">
        <div className="container">
          <Heading_title title={"Product Category"} />

          <div className="slidersec">
            {/* <Tab.Container id="product-tabs" defaultActiveKey={categoryKeys[0]}> */}

            <Tab.Container
              id="product-tabs"
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
            >
              <Nav variant="pills" className="flex-row mb-4">
                {/* {All_products.map((category) => (
                  <Nav.Item key={category.id}>
                    <Nav.Link eventKey={category.id}>
                      {category.category}
                    </Nav.Link>
                  </Nav.Item>
                ))} */}

                {categoryKeys.map((category, index) => (
                  <Nav.Item key={index}>
                    <Nav.Link eventKey={category}>{category}</Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
              <Tab.Content>
                {/* {All_products.map((category) => (
                  <Tab.Pane eventKey={category.id} key={category.id}>
                    <div className="row">
                      {category.products.slice(0, 4).map((product, index) => (
                        <div
                          className="col-lg-3 col-md-4 col-sm-6 col-6 p-1 mb-2"
                          key={index}
                        >
                          <Product_card
                            image={product.image}
                            price={product.price}
                            product_name={product.name}
                            amazon_link={product.amazon_link}
                            bigbasket_link={product.bigbasket_link}
                            blinkit_link={product.blinkit_link}
                            flipcart_link={product.flipcart_link}
                          />
                        </div>
                      ))}
                    </div>
                  </Tab.Pane>
                ))} */}

                {/* Dynamic data */}
                {categoryKeys.map((category, index) => (
                  <Tab.Pane eventKey={category} key={index}>
                    <div className="row">
                      {groupedProducts[category]
                        ?.slice(0, 4)
                        ?.map((product, index) => (
                          <div
                            className="col-lg-3 col-md-4 col-sm-6 col-6 p-1 mb-2"
                            key={index}
                          >
                            <Product_card
                              image={IDS?.IMG_URL + product?.image}
                              price={product?.price}
                              product_name={product?.name}
                              platforms={product?.Product_Platforms || []}
                            />
                          </div>
                        ))}
                    </div>
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Tab.Container>
          </div>

          <div className="text-end mt-3">
            <Link className="seemore" to={"/all-products"}>
              See More <FontAwesomeIcon icon={faArrowRight} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Related_category;
